import { Box, Stack, Text, TextInline } from '@trmediaab/zebra';
import PropTypes from 'prop-types';

import RoundText from '../RoundText';
import { getStart, getWinsText } from './utils';

const KeyStartItem = ({ items, type }) => {
  if (!Object.hasOwn(items, type)) {
    return null;
  }

  const first = items[type][0];

  return (
    <Stack between="3,5">
      {first.text && <RoundText text={first.text} />}

      <Box>
        {type === 'front_favorite' && (
          <Text
            fontWeight="extraBold"
            color="text.tertiary"
            fontSize="0"
            mb="2,5"
          >
            TROLIGASTE SPETSHÄSTEN
          </Text>
        )}

        {items[type].map(item => (
          <Text
            key={item.id}
            fontSize={{
              _: '1',
              md: '2',
            }}
          >
            <TextInline fontWeight="bold">{getStart(item.start)} </TextInline>
            {item.front_total > 0 && (
              <TextInline pl="1">
                ({item.front_wins} {getWinsText(item.front_wins)} på{' '}
                {item.front_total} försök)
              </TextInline>
            )}
          </Text>
        ))}
      </Box>
    </Stack>
  );
};

KeyStartItem.propTypes = {
  items: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default KeyStartItem;
